import React from "react";

// Mapeia grupos → etapas do wizard
export const GROUPS = {
  voce: {
    label: "Você",
    keys: ["marca_momento", "personalidade", "missao_comunidade"],
    color: "#FF7A5A",
    angle: 270, // topo
  },
  mercado: {
    label: "Mercado",
    keys: ["mercado", "mapa_perceptual", "pilares_tensao"],
    color: "#C05BFF",
    angle: 30, // baixo direita
  },
  sociedade: {
    label: "Sociedade",
    keys: ["sociedade_publico", "ponto_a_b", "auditoria_percepcao"],
    color: "#FF4E9E",
    angle: 150, // baixo esquerda
  },
};

const CENTER_KEYS = ["frase_posicionamento", "distribuicao", "plano_90_dias", "documento_final"];

function groupProgress(steps, keys) {
  const filled = keys.filter((k) => {
    const d = steps?.[k]?.data;
    if (!d) return false;
    return Object.values(d).some((v) => v && (Array.isArray(v) ? v.length > 0 : true));
  });
  return filled.length / keys.length;
}

export default function RodaPosicionamento({ steps = {}, size = 280 }) {
  // Add 12% padding so the 3 outer circles never clip the viewBox.
  const pad = size * 0.12;
  const inner = size;
  const total = inner + pad * 2;
  const cx = total / 2, cy = total / 2;
  const outerR = inner * 0.24;
  const centerR = inner * 0.16;
  const dist = inner * 0.28;

  const centerProgress = groupProgress(steps, CENTER_KEYS);
  const centerOpacity = 0.25 + centerProgress * 0.75;

  const nodes = Object.entries(GROUPS).map(([k, g]) => {
    const rad = (g.angle * Math.PI) / 180;
    return {
      key: k,
      x: cx + Math.cos(rad) * dist,
      y: cy + Math.sin(rad) * dist,
      progress: groupProgress(steps, g.keys),
      ...g,
    };
  });

  return (
    <svg viewBox={`0 0 ${total} ${total}`} width="100%" height="100%" style={{ maxWidth: size }} data-testid="roda-posicionamento">
      <defs>
        <linearGradient id="rodaCenter" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FF7A5A" />
          <stop offset="0.55" stopColor="#FF4E9E" />
          <stop offset="1" stopColor="#C05BFF" />
        </linearGradient>
        <filter id="rodaGlow" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation={2 + centerProgress * 5} />
        </filter>
      </defs>

      {/* Connecting lines from each group to center */}
      {nodes.map((n) => (
        <line key={`line-${n.key}`} x1={n.x} y1={n.y} x2={cx} y2={cy}
          stroke={n.color} strokeWidth={1 + n.progress * 2}
          strokeOpacity={0.25 + n.progress * 0.55}
          strokeDasharray={n.progress > 0.5 ? "0" : "4 4"} />
      ))}

      {/* Center circle — "Posicionamento" */}
      <circle cx={cx} cy={cy} r={centerR} fill="url(#rodaCenter)" opacity={centerOpacity} filter="url(#rodaGlow)" />
      <circle cx={cx} cy={cy} r={centerR} fill="none" stroke="url(#rodaCenter)" strokeWidth="1.5" opacity="0.9" />
      <text x={cx} y={cy - 2} textAnchor="middle" fontSize={inner * 0.038} fontWeight="800" fill="#fff" opacity={0.7 + centerProgress * 0.3}>
        Posicionamento
      </text>
      <text x={cx} y={cy + inner * 0.05} textAnchor="middle" fontSize={inner * 0.035} fill="#fff" opacity="0.8">
        {Math.round(centerProgress * 100)}%
      </text>

      {/* Outer nodes */}
      {nodes.map((n) => (
        <g key={n.key}>
          <circle cx={n.x} cy={n.y} r={outerR} fill={n.color} opacity={0.15 + n.progress * 0.3} />
          <circle cx={n.x} cy={n.y} r={outerR} fill="none" stroke={n.color} strokeWidth="1.5" opacity={0.4 + n.progress * 0.6} />
          <text x={n.x} y={n.y - 2} textAnchor="middle" fontSize={inner * 0.05} fontWeight="700" fill="currentColor">
            {n.label}
          </text>
          <text x={n.x} y={n.y + inner * 0.06} textAnchor="middle" fontSize={inner * 0.038} fill="currentColor" opacity="0.6">
            {Math.round(n.progress * 100)}%
          </text>
        </g>
      ))}
    </svg>
  );
}
